<ifb-competitor-form
    [competitor]="competitor$ | async"
    (formStatusChanged)="onCompetitorFormChanged($event)">
</ifb-competitor-form>